import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updateEnvelopeRecipientStep } from "../../../../services/CommonService";
import { getRecipientList } from "../../../../services/Recipients";
import Utils from "../../../../utils";
import EnvelopeRecipients from "./Recipients";
import { Lang } from "../../../../lang";
import Select, { components } from 'react-select';

function EnvelopeStep2(props) {
    const navigate = useNavigate();

    const [docData, setDocData] = useState({
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        country_id: 227,
        company_name: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        address_country_id: "",
        zip_code: "",
    });

    const buttonRef = useRef(null);
    const selectRef = useRef(null);

    const [searchRecipientList, setSearchRecipientList] = useState([]);
    const [recipientSearch, setRecipientSearch] = useState("");
    const [subject, setSubject] = useState("");
    const [emailText, setEmailText] = useState("");

    let errorsObj = {
        recipient: "",
        subject: "",
        email_text: "",
    };
    const [errors, setErrors] = useState(errorsObj);

    useEffect(function () {
        setSubject((props.formObj.subject) ? props.formObj.subject : '');
        setEmailText((props.formObj.email_text) ? props.formObj.email_text : '');
    }, [props]);

    function onBack(e) {
        e.preventDefault();
        const formData = { ...props.formObj };
        formData.current_step = 1;
        props.setFormObj(formData);
        navigate('/client-portal/sleeve/edit/' + formData.envelope_uuid + '/1');
    }

    function onRemoveRecipient(e, index) {
        e.preventDefault();
        const formData = { ...props.formObj };
        formData.recipient_List.splice(index, 1);
        props.setFormObj(formData);
    }

    function onSaveExit(e) {
        e.preventDefault();
        onSubmitForm(1);
    }

    function onNext(e) {
        e.preventDefault();
        onSubmitForm(2);
    }

    function onSubmitForm(type) {
        let error = false;
        const errorObj = { ...errorsObj };
        const formData = { ...props.formObj };

        if (formData.recipient_List.length === 0) {
            errorObj.recipient = "Please add recipient";
            error = true;
        }
        if (!subject) {
            errorObj.subject = "Subject must be required";
            error = true;
        }
        if (!emailText) {
            errorObj.email_text = "Email text must be required";
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        props.setLoading(true);

        let recipientIds = "";
        for (let i = 0; i < formData.recipient_List.length; i++) {
            recipientIds += formData.recipient_List[i]["id"];
            if (formData.recipient_List.length !== i + 1) {
                recipientIds += ",";
            }
        }

        let obj = {
            envelope_id: formData.envelope_id,
            recipient_ids: recipientIds,
            email_subject: subject,
            email_text: emailText,
        };

        updateEnvelopeRecipientStep(obj)
            .then((response) => {
                if (type === 2) {
                    formData.current_step = 3;
                    formData.subject = subject;
                    formData.email_text = emailText;
                    props.setFormObj(formData);
                    navigate('/client-portal/sleeve/edit/' + formData.envelope_uuid + '/3');
                } else {
                    navigate("/manage/draft");
                }
                toast.success(response.data.message);
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    }

    function onEditRecipient(e, obj) {
        e.preventDefault();
        let formData = { ...docData };
        formData.id = obj.id;
        formData.first_name = obj.first_name;
        formData.last_name = obj.last_name;
        formData.email = obj.email;
        formData.mobile = obj.mobile;
        formData.country_id = obj.country_id;
        formData.company_name = obj.company_name ? obj.company_name : "";
        formData.address_1 = obj.address_1 ? obj.address_1 : "";
        formData.address_2 = obj.address_2 ? obj.address_2 : "";
        formData.city = obj.city ? obj.city : "";
        formData.state = obj.state ? obj.state : "";
        formData.zip_code = obj.zip_code ? obj.zip_code : "";
        formData.address_country_id = obj.address_country_id ? obj.address_country_id : "";
        setDocData(formData);
        buttonRef.current?.click();
    }

    function onAddRecipient() {
        setDocData({
            id: 0,
            first_name: "",
            last_name: "",
            email: "",
            mobile: "",
            country_id: 227,
            company_name: "",
            address_1: "",
            address_2: "",
            city: "",
            state: "",
            address_country_id: "",
            zip_code: "",
        });
    }

    const handleEnvInput = (e, type) => {
        let envelopeData = { ...props.formObj };
        if (type === 'subject') {
            setSubject(e.target.value);
            envelopeData.subject = e.target.value;
        } else if (type === 'email_text') {
            setEmailText(e.target.value);
            envelopeData.email_text = e.target.value;
        }
        props.setFormObj(envelopeData);
    };

    const handleRecipientInputChange = (inputValue) => {
        setRecipientSearch(inputValue);
        getRecipientList({ search: inputValue, limit: 50, page: 1 })
            .then((response) => {
                setSearchRecipientList(response.data?.data || []);
            })
            .catch(() => setSearchRecipientList([]));
    };

    const handleRecipientInputFocus = () => {
        if (recipientSearch === "" && searchRecipientList.length === 0) {
            getRecipientList({ search: "", limit: 50, page: 1 })
                .then((response) => {
                    setSearchRecipientList(response.data?.data || []);
                })
                .catch(() => setSearchRecipientList([]));
        }
    };

    const handleSelectRecipient = (selectedOptions) => {
        const options = selectedOptions || [];
        const newRecipientList = options.map(opt => opt.data);
        const formData = { ...props.formObj };
        formData.recipient_List = newRecipientList;
        props.setFormObj(formData);
    };

    const recipientOptions = useMemo(() => {
        return searchRecipientList.map(item => ({
            value: item.email,
            label: `${item.first_name} ${item.last_name} (${item.email})`,
            data: item,
        }));
    }, [searchRecipientList]);

    const currentSelectedValue = recipientOptions.filter(option =>
        props.formObj.recipient_List.some(r => r.email === option.data.email)
    );

    const displayedRecipients = recipientSearch.trim()
        ? props.formObj.recipient_List.filter(
            r =>
                (r.first_name + ' ' + r.last_name).toLowerCase().includes(recipientSearch.toLowerCase()) ||
                r.email.toLowerCase().includes(recipientSearch.toLowerCase()) ||
                (r.mobile && r.mobile.toLowerCase().includes(recipientSearch.toLowerCase()))
        )
        : props.formObj.recipient_List;

    const formatRecipientOption = (option) => {
        const isSelected = props.formObj.recipient_List.some(
            (r) => r.email === option.data.email
        );

        return (
            <div className="d-flex align-items-center w-100">
                <div className={`recipient-dropdown-avatar ${isSelected ? 'selected' : ''}`}>
                    {isSelected ? (
                        <i className="bi bi-check-lg"></i>
                    ) : (
                        option.data.first_name?.[0]?.toUpperCase() || ""
                    )}
                </div>

                <div className="ms-3 d-flex flex-wrap align-items-center flex-grow-1 recipient-option-info">
                    <div className="fw-bold text-dark recipient-option-name">
                        {option.data.first_name + " " + option.data.last_name}
                    </div>
                    <div className="fw-medium recipient-option-email">
                        &lt;{option.data.email}&gt;
                    </div>
                    {option.data.mobile && (
                        <div className="recipient-option-mobile">
                            | {Utils.mobileFormat(option.data)}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // FIX: Wrapped CustomMenuList in useMemo to prevent re-creation on render.
    // This fixes the scroll jumping to top issue.
    const CustomMenuList = useMemo(() => (props) => {
        return (
            <components.MenuList {...props}>
                {props.children}
                <div className="recipient-menu-footer">
                    <button
                        className="btn btn-primary btn-sm"
                        onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            selectRef.current.blur();
                        }}
                    >
                        Done / Close
                    </button>
                </div>
            </components.MenuList>
        );
    }, []);

    return (
        <div className="sleeve-gradient-bg sleeve-step">
            <div className="sleeve-main-card">

                {/* Custom Header */}
                <div className="sleeve-contract-setup-header">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <div className="sleeve-contract-title">Collaborator Details</div>
                            <div className="sleeve-contract-subtitle">Add people who need to sign or review.</div>
                        </div>
                        <div className="text-end">
                            <div className="sleeve-step-indicator-custom">Step 2 of 4</div>
                        </div>
                    </div>
                </div>

                {/* Recipient Details Card */}
                <div className="sleeve-sender-card mb-4">
                    <div className="recipient-details-card-custom-add ">
                        <div className="align-items-center gap-2">
                            <span className="sleeve-heading">
                                <i className="bi bi-person-fill-add me-2"></i>
                                <span>
                                    Collaborator Details
                                    <i className="bi bi-info-circle ms-1 cur-pointer fs-6 text-muted" aria-hidden="true" data-toggle="tooltip"
                                        data-placement="left" title={"Enter one or more email addresses of people you want to collaborate with on this contract. Each collaborator will receive a secure, personalized link to review and contribute."} />
                                </span>
                            </span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <button className="d-none" ref={buttonRef} data-bs-toggle="offcanvas" data-bs-target="#addRecipients"></button>
                            <button
                                type="button"
                                className="step2-add-btn ms-auto"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#addRecipients"
                                aria-controls="addRecipients"
                                data-toggle="tooltip"
                                title={Lang.env_add_recipient}
                                onClick={onAddRecipient}
                            >
                                <span className="me-2">+</span>Add Collaborator
                            </button>
                        </div>
                    </div>
                    <div className="mb-3">
                        <Select
                            ref={selectRef}
                            classNamePrefix="sleeve-sender-select"
                            value={currentSelectedValue}
                            isMulti
                            closeMenuOnSelect={false}
                            controlShouldRenderValue={false}
                            hideSelectedOptions={false}
                            components={{ MenuList: CustomMenuList }}
                            maxMenuHeight={500}
                            inputValue={recipientSearch}
                            onInputChange={handleRecipientInputChange}
                            onFocus={handleRecipientInputFocus}
                            onChange={handleSelectRecipient}
                            options={recipientOptions}
                            placeholder="Search & Select Multiple Collaborators"
                            isClearable={false}
                            isSearchable
                            formatOptionLabel={formatRecipientOption}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderRadius: 6,
                                    minHeight: 48,
                                    borderColor: errors.recipient ? '#dc3545' : '#e3e8f0',
                                    boxShadow: 'none',
                                    background: '#fff'
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    background: state.isFocused ? '#f3f4f6' : '#fff',
                                    color: '#222',
                                    cursor: 'pointer',
                                    padding: '6px 12px',
                                    borderBottom: '1px solid #f8f9fa'
                                }),
                                menu: (base) => ({ ...base, zIndex: 99 }),
                                input: (base) => ({ ...base, fontSize: '1rem' }),
                            }}
                        />
                        {errors.recipient && (
                            <div className="error-message">{errors.recipient}</div>
                        )}
                    </div>

                    {/* Recipient List or Empty State */}
                    {displayedRecipients.length === 0 ? (
                        <div className="step2-empty-state">
                            <div className="icon"><i className="bi bi-people" /></div>
                            <div>No collaborator added yet</div>
                            <div className="small">Click "Add Collaborator" to get started</div>
                        </div>
                    ) : (
                        <div className="gap-2 w-100">
                            {displayedRecipients.map((item, index) => (
                                <div className="recipient-list-item-custom" key={index}>
                                    <div className="recipient-list-info">
                                        <div className="recipient-info-user">
                                            <div className="avatar-circle-custom">{item.first_name?.[0]?.toUpperCase() || ''}</div>
                                            <div className="fw-bold recipient-name">{item.first_name + ' ' + item.last_name}</div>
                                        </div>
                                        <div className="recipient-email-mobile">
                                            <span className="text-dark">{item.email}</span>
                                            <span className="text-dark">{Utils.mobileFormat(item)}</span>
                                        </div>
                                    </div>
                                    <div className="recipient-list-actions">
                                        <span className="text-primary fs-5 cursor-pointer" onClick={(e) => onEditRecipient(e, item)}>
                                            <i className="bi bi-pencil-square" />
                                        </span>
                                        <span className="text-danger fs-5 cur-pointer" onClick={(e) => onRemoveRecipient(e, index)}>
                                            <i className="bi bi-x-lg" />
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Email Details Card */}
                <div className="sleeve-sender-card mb-4">
                    <div className="sleeve-heading mb-2">
                        <span>
                            <i className="bi bi-envelope-check me-2" />
                            Email Details
                        </span>
                    </div>
                    <div className="mb-3">
                        <label className="sleeve-step-label">Subject</label>
                        <input
                            type="text"
                            className={`sleeve-step-input ${errors.subject ? "input-error" : ""}`}
                            value={subject}
                            onChange={e => handleEnvInput(e, 'subject')}
                            placeholder="Enter Email Subject"
                        />
                        {errors.subject && (
                            <div className="error-message">{errors.subject}</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label className="sleeve-step-label">Email Text</label>
                        <textarea
                            className="sleeve-step-textarea"
                            rows={8}
                            value={emailText}
                            onChange={e => handleEnvInput(e, 'email_text')}
                            placeholder="Enter Email text box"
                        />
                        {errors.email_text && (
                            <div className="error-message">{errors.email_text}</div>
                        )}
                    </div>
                </div>
                {/* Recipient Add/Edit Offcanvas */}
                <EnvelopeRecipients formObj={props.formObj} setFormObj={props.setFormObj} setLoading={props.setLoading}
                    recipData={docData} setDocData={setDocData} />
                <div className="sleeve-step-buttons">
                    <div>
                        <button className="sleeve-btn-back" onClick={onBack}>
                            Back
                        </button>
                    </div>
                    <div className="sleeve-step-buttons-right">
                        <button className="sleeve-btn-save" onClick={onSaveExit}>
                            Save & Exit
                        </button>
                        <button className="sleeve-btn-next" onClick={onNext}>
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnvelopeStep2;